export enum SideNavResponse {
  SUBMMITED = 'SUBMMITED',
  CLOSED = 'CLOSED'
}
